module.exports = __webpack_public_path__ + "static/img/my account_recharge_alipay@2x.f3b1100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pics/my account_recharge_alipay@2x.png
// module id = ANfF
// module chunks = 1